import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import { IconButton, InputAdornment, CircularProgress, Tooltip } from "@material-ui/core";
import { Visibility, VisibilityOff, Business, Description, VpnKey, Storage, Lock, Language, AccountCircle, Group as GroupIcon, InsertLink, LinkOff } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import styled, { keyframes } from "styled-components";
import fetchClient from "../../api/fetchClient";

function TabEmpresaAriba({
  values,
  touched,
  errors,
  handleChange,
  onTestConnect,
  onTestConnectHana,
  connected,
  connectedHana,
  isLoading,
  isLoadingHana
}) {
  const [grupos, setGrupos] = useState([]);
  const [passwordVisibility, setPasswordVisibility] = React.useState({
    login: false,
    password: false,
    hPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const { data } = await fetchClient.get("/ariba/getAllGroups");
        setGrupos(data);
      } catch (error) {
        console.error("Erro ao buscar grupos:", error);
      }
    };

    fetchGrupos();
  }, []);

  return (
    <ModernFormContainer>
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#667eea">
              <Business />
            </SectionIcon>
            <SectionTitle>Informações Gerais</SectionTitle>
          </SectionHeader>
          <FormGrid columns={2}>
            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                ID
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
                id="id"
                name="id"
                placeholder="ID gerado automaticamente"
                value={values.id}
                onChange={handleChange}
                error={touched.id && Boolean(errors.id)}
                helperText={touched.id && errors.id}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
            <StyledFieldContainer>
              <FieldLabel>
                <GroupIcon style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                Grupo
              </FieldLabel>
              <TextField
                select
                fullWidth
                id="grupoId"
                name="grupoId"
                placeholder="Selecione um grupo"
                value={values.grupoId || ""}
                onChange={handleChange}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                error={touched.grupoId && Boolean(errors.grupoId)}
                helperText={touched.grupoId && errors.grupoId}
              >
                {grupos.map((grupo) => (
                  <MenuItem key={grupo.id} value={grupo.id}>
                    {grupo.id}
                  </MenuItem>
                ))}
              </TextField>
            </StyledFieldContainer>
            <FormLabel>
              <Checkbox
                id="master"
                name="master"
                checked={values.master}
                onChange={(e) => handleChange({ target: { name: "master", value: e.target.checked } })}
                color="primary"
              />
              <StatusText active={values.master}>
                {values.master ? "✓ Master Ativo" : "✗ Master Inativo"}
              </StatusText>
            </FormLabel>
            <FormLabel>
              <Checkbox
                id="enabled"
                name="enabled"
                checked={values.enabled}
                onChange={(e) => handleChange({ target: { name: "enabled", value: e.target.checked } })}
                color="primary"
              />
              <StatusText active={values.enabled}>
                {values.enabled ? "✓ Ativo" : "✗ Inativo"}
              </StatusText>
            </FormLabel>
          </FormGrid>
        </SectionCard>
      )}

      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#3498db">
            <Description />
          </SectionIcon>
          <SectionTitle>Dados da Empresa</SectionTitle>
        </SectionHeader>
        <FormGrid columns={2}>
          <StyledFieldContainer>
            <FieldLabel>
              <Business style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
              CNPJ
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="cnpj"
              name="cnpj"
              placeholder="00.000.000/0000-00"
              value={values.cnpj}
              onChange={handleChange}
              error={touched.cnpj && Boolean(errors.cnpj)}
              helperText={touched.cnpj && errors.cnpj}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <FieldLabel>
              <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
              Nome da Empresa
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="name"
              name="name"
              placeholder="Nome da empresa"
              value={values.name}
              onChange={handleChange}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
          <StyledFieldContainer fullWidth>
            <FieldLabel>
              <Description style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />
              Descrição
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="description"
              name="description"
              placeholder="Descrição detalhada da aplicação"
              value={values.description}
              onChange={handleChange}
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
              autoComplete="off"
              variant="outlined"
              multiline
              rows={2}
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <FieldLabel>
              <Storage style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
              Série Fornecedor
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="series"
              name="series"
              placeholder="Série do fornecedor"
              value={values.series}
              onChange={handleChange}
              error={touched.series && Boolean(errors.series)}
              helperText={touched.series && errors.series}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>

      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#e74c3c">
            <VpnKey />
          </SectionIcon>
          <SectionTitle>Configurações SAP</SectionTitle>
          {onTestConnect && (
            <ConnectionButton
              onClick={onTestConnect}
              connected={connected}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={18} style={{ color: 'white' }} />
              ) : (
                <Tooltip title={connected ? "Conectado ao SAP" : "Testar conexão SAP"}>
                  {connected ? <InsertLink /> : <LinkOff />}
                </Tooltip>
              )}
            </ConnectionButton>
          )}
        </SectionHeader>
        <FormGrid columns={2}>
          <StyledFieldContainer>
            <FieldLabel>
              <Storage style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
              Banco de Dados SAP
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="database"
              name="database"
              placeholder="Nome do banco de dados"
              value={values.database}
              onChange={handleChange}
              error={touched.database && Boolean(errors.database)}
              helperText={touched.database && errors.database}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
              Login SAP
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="login"
              name="login"
              placeholder="Usuário do SAP"
              value={values.login}
              onChange={handleChange}
              error={touched.login && Boolean(errors.login)}
              helperText={touched.login && errors.login}
              autoComplete="off"
              variant="outlined"
              type={passwordVisibility.login ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility("login")}
                      edge="end"
                    >
                      {passwordVisibility.login ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
              Senha SAP
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="password"
              name="password"
              placeholder="Senha do SAP"
              value={values.password}
              onChange={handleChange}
              error={touched.password && Boolean(errors.password)}
              helperText={touched.password && errors.password}
              autoComplete="off"
              variant="outlined"
              type={passwordVisibility.password ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility("password")}
                      edge="end"
                    >
                      {passwordVisibility.password ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <Language style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />
              URL Service Layer SAP
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="url"
              name="url"
              placeholder="https://servicelayer:port/b1s/v1"
              value={values.url}
              onChange={handleChange}
              error={touched.url && Boolean(errors.url)}
              helperText={touched.url && errors.url}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>

      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#16a085">
            <Storage />
          </SectionIcon>
          <SectionTitle>Configurações HANA (Opcional)</SectionTitle>
          {onTestConnectHana && (
            <ConnectionButton
              onClick={onTestConnectHana}
              connected={connectedHana}
              disabled={isLoadingHana}
            >
              {isLoadingHana ? (
                <CircularProgress size={18} style={{ color: 'white' }} />
              ) : (
                <Tooltip title={connectedHana ? "Conectado ao HANA" : "Testar conexão HANA"}>
                  {connectedHana ? <InsertLink /> : <LinkOff />}
                </Tooltip>
              )}
            </ConnectionButton>
          )}
        </SectionHeader>
        <FormGrid columns={2}>
          <StyledFieldContainer>
            <FieldLabel>
              <Language style={{ fontSize: '18px', marginRight: '8px', color: '#1abc9c' }} />
              URL HANA SQL
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="urlHanaSql"
              name="urlHanaSql"
              placeholder="jdbc:sap://host:port"
              value={values.urlHanaSql}
              onChange={handleChange}
              error={touched.urlHanaSql && Boolean(errors.urlHanaSql)}
              helperText={touched.urlHanaSql && errors.urlHanaSql}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#2980b9' }} />
              Usuário HANA
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="hUserName"
              name="hUserName"
              placeholder="Usuário HANA"
              value={values.hUserName}
              onChange={handleChange}
              error={touched.hUserName && Boolean(errors.hUserName)}
              helperText={touched.hUserName && errors.hUserName}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel>
              <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#c0392b' }} />
              Senha HANA
            </FieldLabel>
            <TextField
              InputLabelProps={{ shrink: true }}
              fullWidth
              id="hPassword"
              name="hPassword"
              placeholder="Senha HANA"
              value={values.hPassword}
              onChange={handleChange}
              error={touched.hPassword && Boolean(errors.hPassword)}
              helperText={touched.hPassword && errors.hPassword}
              autoComplete="off"
              variant="outlined"
              type={passwordVisibility.hPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility("hPassword")}
                      edge="end"
                    >
                      {passwordVisibility.hPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>

      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#9b59b6">
              <Storage />
            </SectionIcon>
            <SectionTitle>Configurações Avançadas</SectionTitle>
          </SectionHeader>
          <FormGrid columns={1}>
            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />
                Token
              </FieldLabel>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="token"
                name="token"
                placeholder="Token de autenticação"
                value={values.token}
                disabled
                error={touched.token && Boolean(errors.token)}
                helperText={touched.token && errors.token}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
            <FormLabel>
              <Checkbox
                id="metadata"
                name="metadata"
                checked={values.metadata}
                onChange={handleChange}
                color="primary"
              />
              <StatusText active={values.metadata}>
                Habilitar criação automática de tabelas e campos no SAP
              </StatusText>
            </FormLabel>
          </FormGrid>
        </SectionCard>
      )}
    </ModernFormContainer>
  );
}

export default TabEmpresaAriba;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const ConnectionButton = styled.button`
  margin-left: auto;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  background: ${props => {
    if (props.disabled) return '#e0e0e0';
    return props.connected
      ? 'linear-gradient(135deg, #27ae60 0%, #229954 100%)'
      : 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)';
  }};
  color: white;

  &:hover {
    transform: ${props => props.disabled ? 'none' : 'scale(1.1)'};
    box-shadow: ${props => {
      if (props.disabled) return 'none';
      return props.connected
        ? '0 4px 12px rgba(39, 174, 96, 0.4)'
        : '0 4px 12px rgba(243, 156, 18, 0.4)';
    }};
  }

  svg {
    font-size: 20px;
  }
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.color ? `${props.color}15` : '#667eea15'};
  color: ${props => props.color || '#667eea'};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${SectionCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;

const FormLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(102, 126, 234, 0.05);
    border-radius: 8px;
    padding: 12px 8px;
  }
`;

const StatusText = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${props => props.active ? '#27ae60' : '#7f8c8d'};
  font-family: 'Mulish', sans-serif;
  transition: color 0.3s ease;
`;
